import React from "react";
import { observable, action } from "mobx";
import * as Api from "api";
import * as ChurnSegment from "api/agencies/ChurnSegment";

export class ChurnSegmentStore {
  @observable.ref
  public loading = false;

  @observable.ref
  public churnSegments: ChurnSegment.IndexResponse[] = [];

  @action.bound
  public async fetchChurnSegment(agencyId: number, appId: number) {
    this.loading = true;

    const response = await ChurnSegment.Api.index(agencyId, {
      appId,
    });

    if (response?.status === Api.Status.OK) {
      this.churnSegments = response.data;
    }

    this.loading = false;
  }
}

const Context = React.createContext<ChurnSegmentStore | null>(null);

export const ChurnSegmentStoreProvider: React.FC<{
  value?: ChurnSegmentStore;
}> = ({ children, value }) => {
  const store = React.useMemo(() => (value ? value : new ChurnSegmentStore()), [
    value,
  ]);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export const useChurnSegmentStore = () => {
  const store = React.useContext(Context);
  if (!store) {
    throw new Error(
      "useChurnSegmentStore must be used within a ChurnSegmentStoreProvider."
    );
  }
  return store;
};
